import { ChangeExecutionType } from '@wix/ambassador-premium-purchase-platform-v1-offering/types';
export const isCycleAvailableForUpgrade = changeCycle => {
  var _changeCycle$actions;
  return Boolean((_changeCycle$actions = changeCycle.actions) == null ? void 0 : _changeCycle$actions.some(action => action.changeExecution === ChangeExecutionType.PAYMENT_REQUIRED));
};
export const getAvailableUpgradeCycles = product => {
  const availableCycles = [];
  if (product.subscriptionChangeCycles && product.subscriptionChangeCycles.length > 0) {
    product.subscriptionChangeCycles.forEach(changeCycle => {
      if (isCycleAvailableForUpgrade(changeCycle) && changeCycle.cycle) {
        availableCycles.push(changeCycle.cycle);
      }
    });
  }
  return availableCycles;
};
//# sourceMappingURL=utils.js.map